import { _,moment,Datepicker } from '../../../vendor'
import Inboomai18n from '../../utils/Inboomai18n'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'
import InboomaBaseView from '../InboomaBaseView'

import ContingentNumbersListTpl from '../../templates/contingents/ContingentNumbersListTpl.html'

// this refs #20207

const ContingentNumber = InboomaBaseView.extend({

    tagName : 'div',
    className : 'inb-reservation-contingent-item contingent-number-item row',
    template: _.template(`

        <aside class="inb-c-item__actions" style="margin-top:0;">
            <button class="button round contingent-amount-remove"
             type="button"
             title="<%= t('remove') %>">
               <i class="fi fi-trash"></i>
            </button>
        </aside>

        <div class="small-6 column">
            <div class="input-group inb-price-input-group">
                <input 
                 class="input-group-field"
                 type="text"
                 name="valid_from_date_field"
                 value="<%- date.format('D. MMMM YYYY') %>"
                />
                <input 
                 class="input-group-field"
                 type="text"
                 name="valid_from_time_field"
                 value="<%- date.format('HH:mm') %>"
                 style="max-width: 40%;"
                />
               <!-- <span class="input-group-label">
                  <i class="fi fi-calendar"></i>
                </span> -->
            </div>
        </div>

        <div class="hide small-3 small-offset-1 column">
            <input 
             type="text"
             disabled="disabled"
             value="<%- valid_from %>"
            />
        </div>

        <div class="medium-2 medium-offset-1 column">
            <input
             class=""
             type="text"
             name="number_field"
             value="<%- number %>"
            />
        </div>
    `),

    ui : {
        'contingentAmountRemove' : '.contingent-amount-remove',
        'validFromDateField' : 'input[name="valid_from_date_field"]',
        'validFromTimeField' : 'input[name="valid_from_time_field"]',
        'numberField' : 'input[name="number_field"]'
    },

    events : {
        'click @ui.contingentAmountRemove' : '_remove',
        'focusout @ui.numberField' : '_setNumber',
        'focusout @ui.validFromTimeField' : '_setValidFromTime'
    },

    modelEvents : {
        'change:valid_from' () {
            this.model.collection.sort();
        }
    },

    templateContext () {
        return {
            'date' : this._date,
        }
    },

    _setNumber () {
        this.model.set('number', this.getUI('numberField').val());
    },

    _setValidFromTime () {

        const val = this.getUI('validFromTimeField').val();

        if (val.length === 2 && val.indexOf(':') === -1) {
            // User typed e.g. "12" -> make "12:00", then re-check
            this.getUI('validFromTimeField').val(val + ':00');
            this._setValidFromTime();
            return;
        }

        const valSplitted = val.split(':');

        if (valSplitted.length === 2 
            && valSplitted[0].length === 2
            && valSplitted[1].length === 2
            && Number(valSplitted[0]) <= 23 
            && Number(valSplitted[1]) <= 59) {
            
            this._date.set('hour', Number(valSplitted[0]))
                      .set('minute', Number(valSplitted[1]));

            this.model.set('valid_from', this._date.format('YYYY-MM-DD HH:mm:00'));
            
        } else {
            // Reset previous, valid time value
            this.getUI('validFromTimeField')
                .val(this._date.format('HH:mm'));
        }

    },

    _remove () {
        // Do not call directly this.model.destroy()
        // as this would trigger an API-request with DELETE method

        if (typeof this.model !== 'undefined') {
            this.model.collection.off('add remove', this._toggleRemoveBtn, this);
            this.model.collection.remove(this.model);
            this.destroy();
        }
    },

    _changeValidTillOfPrevModel () {
         /*
            @todo Sketch to change pseudo "valid_till" value
            on previous view/model

            const modelIndex = collection.indexOf(model);

            if (modelIndex >= 1) {
                console.log(collection.at(modelIndex - 1));
            }
            ...
        */
    },

    _toggleRemoveBtn () {

        if (typeof this._ui === 'undefined') return;

        const that = this;

        window.setTimeout(() => {
            // If only one item is visible, hide the trash bin icon

            const visibleItems = document.querySelectorAll('.contingent-number-item');

            that.getUI('contingentAmountRemove')
                .toggleClass('hide', visibleItems.length === 1);

        }, 200);

    },

    initialize () {

        this.model.collection.on('add remove', this._toggleRemoveBtn, this);
        this._date = moment(this.model.get('valid_from'));

    },

    onRender () {

        const model = this.model,
              date = this._date,
              datepicker = new Datepicker({

            field : this.getUI('validFromDateField')[0],
            i18n : Inboomai18n.getPikadayI18n(),
            format : 'D. MMMM YYYY',
            firstDay : 1, // monday
            //minDate : new Date(),
            onSelect () {

                const newDate = this.getMoment()
                                    .format('YYYY-MM-DD')
                                    .split('-');

                date.set('year', Number(newDate[0]))
                    .set('month', Number(newDate[1]) - 1)
                    .set('date', Number(newDate[2]));

                model.set('valid_from', date.format('YYYY-MM-DD HH:mm:00'));
            
            },

        });

        this._toggleRemoveBtn();

    }

});

export default InboomaBaseCollectionView.extend({

    template: ContingentNumbersListTpl,
    childView: ContingentNumber,
    childViewContainer: '.contingents-list',

    ui : {
        'addContingentNumber' : '.contingent-number__add'
    },

    events : {
        'click @ui.addContingentNumber a' : '_addContingentNumber'
    },

    /**
     * DISABLED HIDING OF CERTAIN ELEMENTS [#21304]
     * viewFilter (view, index, children) {

        // Hide rows with outdated valid_from, but show at least one row (as requested by ticket)
        if (children.length - 1 === index 
         || typeof view.wasAlreadyRendered !== 'undefined'
         || moment(view.model.get('valid_from')).isSameOrAfter(moment().hours(0).minutes(0))) {
            view.wasAlreadyRendered = true;
            return true;
        }

        return false;
    },*/

    _addContingentNumber () {

        let latestValidFrom = moment(),
            latestNumber = 1;

        if (this.collection.models.length >= 1) {
            latestValidFrom = moment(this.collection.models[this.collection.models.length - 1].get('valid_from')).add(1,'day');

            if (latestValidFrom.isBefore(moment())) {
                latestValidFrom = moment();
            }

            latestNumber = this.collection.models[this.collection.models.length - 1].get('number');
        }

        this.collection.add({
            'valid_from' : latestValidFrom.format('YYYY-MM-DD 00:00:00'),
            'number' : latestNumber,
        });

    },

    initialize () {
        
        if (this.collection.models.length === 0) {
            // Add one default row
            this._addContingentNumber();
        }

        this.render();

        console.log('COLL', this.collection.models);
    },

    /**
     * @return {Array<Object>}
     */
    returnFormattedContingentAmounts () {

        const contingent_id = this.getOption('contingent_id');

        return _.map(this.collection.models, (model) => {
            
            let result = {
                'valid_from' : model.get('valid_from'),
                'number' : Number(model.get('number'))
            }

            if (typeof model.get('id') !== 'undefined') {
                result.id = model.get('id');
            }

            if (contingent_id !== '' && contingent_id !== null) {
                result.contingent_id = Number(contingent_id);
            }

            return result;
        });

    }

});